import { SelectItem } from '@wui/common-library'

import { BlfTypes } from '../types'

export const isConfiguredButtonsRestricted = (
  isConfiguredButtonsSupported?: boolean | undefined,
): boolean => isConfiguredButtonsSupported === false

type GetAllowedBlfTypesOptions = {
  currentType: BlfTypes
  isConfiguredButtonsSupported?: boolean | undefined
}

export const getAllowedBlfTypes = (
  allTypes: SelectItem[],
  {
    currentType,
    isConfiguredButtonsSupported,
  }: GetAllowedBlfTypesOptions,
): SelectItem[] => {
  const isOwnLine = currentType === BlfTypes.LINE

  if (isConfiguredButtonsRestricted(isConfiguredButtonsSupported)) {
    const currentTypeItems = allTypes.filter((item) => item.value === currentType)
    if (!isOwnLine && currentTypeItems.length > 0) {
      return currentTypeItems
    }

    return allTypes.filter((item) => item.value === BlfTypes.LINE)
  }

  if (isOwnLine) {
    return allTypes
  }

  return allTypes.filter((item) => item.value !== BlfTypes.LINE)
}
